import { AGENT_HUB_AUTH_ROLE_AFFILIATION_ADMIN, AGENT_HUB_AUTH_ROLE_AGENCY_ADMIN } from '~/consts/agentHub';

import type { Agent } from '~/types/services/agentHub';

type AgentMaybeRoles = Agent & { roles?: Array<string> };

export function resolveAgentHubAdminDisplayFlags(user: Agent | undefined): {
  isAgencyAdmin: boolean;
  isAffiliationAdmin: boolean;
} {
  if (!user) {
    return { isAgencyAdmin: false, isAffiliationAdmin: false };
  }

  const roles = (user as AgentMaybeRoles).roles;
  if (Array.isArray(roles) && roles.length > 0) {
    return {
      isAgencyAdmin: roles.includes(AGENT_HUB_AUTH_ROLE_AGENCY_ADMIN),
      isAffiliationAdmin: roles.includes(AGENT_HUB_AUTH_ROLE_AFFILIATION_ADMIN),
    };
  }

  return {
    isAgencyAdmin: user.isAgencyAdmin === true,
    isAffiliationAdmin: user.isAffiliationAdmin === true,
  };
}
